import service from '@/store/services/admin_reports-service';

const state = {
    adminReportsList: {},
    adminDayReport: {},

};

const mutations = {
    SET_ADMIN_REPORT_LIST: (state, adminReportsList) => {
        state.adminReportsList = adminReportsList;
    },
    SET_ADMIN_DAY_REPORT: (state, adminDayReport) => {
        state.adminDayReport = adminDayReport;
    },
};

const actions = {
    adminReportsList({commit, dispatch}, params) {
        return service.getAdminReports(params)
            .then(({adminReportsList}) => {
                commit('SET_ADMIN_REPORT_LIST', adminReportsList);
            });
    },
    adminDayReport({commit, dispatch}, params) {
        return service.getAdminDayReport(params)
            .then(({adminDayReport}) => {
                commit('SET_ADMIN_DAY_REPORT', adminDayReport);
            });
    },



};

const getters = {
    adminReportsList: state => state.adminReportsList,
    adminDayReport: state => state.adminDayReport,
};

const adminReport = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default adminReport;